import { observer } from "mobx-react";
import { ICompareValueStore } from "../../../../../../stores/compare-value/compare-value-factory";
import ConditionBuilderStore from "../../../../../../stores/condition-builder-store";
import { DROPDOWN_MENU_WIDTH, SelectDropdown } from "../../../../../../../../components/inputs/select-dropdown/select-dropdown";
import { CONDITION_OPERATORS } from "../../../../../../policy-types";


export interface ICompareValueTypeComponentProps {
    store: ICompareValueStore<any>,
    condition: ConditionBuilderStore,
    operatorSelector?: React.ReactNode,
}

interface IConditionFieldProps {
    condition: ConditionBuilderStore;
}

const ConditionField: React.FC<IConditionFieldProps> = observer(({condition}) => {
    if (!condition.compareValueStore) {
        return null;
    }

    const operatorSelector = <SelectDropdown
                    disabled={!condition.isEditMode}
                    value={condition.operators.find(o => o.value === condition.operator)}
                    options={condition.operators}
                    onChange={(e) => condition.setOperator(e?.value as CONDITION_OPERATORS)}
                    menuWidth={DROPDOWN_MENU_WIDTH.MAX_CONTENT}
                    isSearchable={false}
                />

    const Component = condition.compareValueStore.Component;

    return <Component store={condition.compareValueStore} condition={condition} operatorSelector={operatorSelector} />
});

export default ConditionField;